import React from 'react';

import StockSpecialFilterCheckbox from '@/components/StockSpecialFilterCheckbox';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarApproved,
  setPage,
} from '@/store/reducers/cars-stock';
import { OptionType } from '@/typings/common';
import { getSpecialFilterOptionById } from '@/modules/CarsStock/components/common.helpers';
import { CarsStockFlag } from '@/services/stock/enums';

export function ApprovedFilter() {
  const dispatch = useTypedDispatch();
  const selectedApproved =
    useTypedSelector(getSelectedFilters).selectedParams.selectedSpecials
      .selectedApproved;
  const stockFilterParams = useTypedSelector(getStockFilterParams);

  const approvedOption = getSpecialFilterOptionById(
    stockFilterParams,
    CarsStockFlag.Approved
  );

  const handleChangeApproved = (approved: OptionType) => {
    if (!selectedApproved.value) {
      dispatch(setCarApproved(approved));
    } else {
      dispatch(setCarApproved({ label: '', value: '' }));
    }
    dispatch(setPage(1));
  };

  return (
    <StockSpecialFilterCheckbox
      checked={!!selectedApproved.value}
      option={approvedOption}
      onChange={handleChangeApproved}
    />
  );
}
